import { useIsMobile } from "@volca/ui/hooks/use-mobile";
import { useImpersonation } from "@/core/impersonation";

export const useDevPopoverOffset = () => {
  const isMobile = useIsMobile();
  const { isImpersonating } = useImpersonation();
  return isMobile && isImpersonating ? 64 : 8;
};
